import {
  mapPersonType,
  mapUserType,
  useFindPersonAssignableUsersSuspense,
  useFindPersonDetailsSuspense,
} from '@api';
import {
  EditActionIcon,
  TouringCard,
  TouringCardActions,
  TouringCardHeader,
  TouringCardSection,
  TouringCardTitle,
} from '@common';
import { usePermissionContext } from '@hypeit-gmbh/hypeit-ui-core';
import { Modal } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { useTranslation } from 'react-i18next';
import { Route } from 'src/routes/_rootLayout/persons/$id.general';
import {
  EditPrivateInformationForm,
  PrivateInformationTable,
} from './components';

export const PersonPrivateInformation: React.FC = () => {
  const { t } = useTranslation('personDetailsGeneral');
  const { id } = Route.useParams();
  const [opened, { open: openModal, close: closeModal }] = useDisclosure(false);
  const { data: personDetails } = useFindPersonDetailsSuspense(id, {
    query: { select: (data) => mapPersonType(data.data) },
  });
  const { data: users } = useFindPersonAssignableUsersSuspense(id, {
    query: {
      select: (data) => data.data.map((user) => mapUserType(user)),
    },
  });
  const { hasPermission } = usePermissionContext();

  const userCanEditPerson = hasPermission({
    permission: 'ADDRESSBOOK_PERSONS',
    action: 'WRITE',
  });

  return (
    <>
      <TouringCard data-testid="person-private-information">
        <TouringCardHeader>
          <TouringCardTitle>{t('PRIVATE_INFORMATION.TITLE')}</TouringCardTitle>
          {userCanEditPerson && (
            <TouringCardActions>
              <EditActionIcon onClick={openModal} />
            </TouringCardActions>
          )}
        </TouringCardHeader>
        <TouringCardSection>
          <PrivateInformationTable personDetails={personDetails} />
        </TouringCardSection>
      </TouringCard>
      <Modal
        opened={opened}
        onClose={closeModal}
        size="lg"
        title={t('PRIVATE_INFORMATION.EDIT_MODAL_TITLE')}
      >
        <EditPrivateInformationForm
          personDetails={personDetails}
          users={users}
          onClose={closeModal}
        />
      </Modal>
    </>
  );
};
